  <template>
      <ul class="info-list">
        <li
          v-for="info in infos"
          :key="info.id"
          class="info-item"
          @click="openPdf(info)"
        >
          {{ info.name }}
        </li>
      </ul>

      <div
        v-if="showPdfModal"
        class="modal-overlay"
        @click.self="closeModal"
      >
        <div class="modal" ref="pdfModal">
          <button class="close-btn" @click="closeModal">×</button>
          <iframe
            :src="pdfSrc"
            width="100%"
            height="600px"
            frameborder="0"
          ></iframe>
        </div>
      </div>
  </template>

  <script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'InfosComponent',
    data() {
      return {
        selectedInfo: null,
        showPdfModal: false
      };
    },
    created() {
      this.$store.dispatch('loadInfos');
    },
    computed: {
      ...mapGetters(['getInfos']),
      infos() {
        return this.getInfos;
      },
      pdfSrc() {
        if (!this.selectedInfo) return '';
        const file = this.selectedInfo.file;
        if (file.startsWith('data:application/pdf')) {
          return file;
        }
        return `data:application/pdf;base64,${file}`;
      }
    },
    methods: {
      openPdf(info) {
        if (this.isIOS()) {
          // Build a Blob URL instead of using an iframe
          const file = info.file.startsWith('data:application/pdf')
            ? info.file.split(',')[1] // strip "data:application/pdf;base64,"
            : info.file;

          const bytes = this.base64ToUint8Array(file);
          const blob = new Blob([bytes], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          // Open in a new tab (more reliable zoom/controls on iOS)
          window.open(url, '_blank', 'noopener,noreferrer');

          // Optional: clean up later (can also store and revoke when modal closes)
          setTimeout(() => URL.revokeObjectURL(url), 60_000);
          return;
        }

        // Non-iOS: keep your modal/iframe flow
        this.selectedInfo = info;
        this.showPdfModal = true;
        this.$nextTick(() => {
          this.$refs.pdfModal.scrollTop = 0;
        });
      },
      closeModal() {
        this.showPdfModal = false;
        this.selectedInfo = null;
      },
      isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS
      },
      base64ToUint8Array(base64) {
        const raw = atob(base64);
        const arr = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
        return arr;
      }
    }
  };
  </script>

  <style scoped>
  .info-list {
    list-style: none;
    padding: 0;
    margin: 1rem auto;
    max-width: 800px;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    text-align: start;
  }

  .info-item {
    padding: 1rem;
    border-bottom: 1px solid #eee;
    color: #1E1C66;
    transition: transform 0.2s, background-color 0.2s;
    cursor: pointer;
    transform-origin: center;
    text-align: start;
  }

  .info-item:hover {
    background-color: #f9f9f9;
    transform: scale(1.03);
  }

  .info-item:last-child {
    border-bottom: none;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .modal {
    background: #fff;
    border-radius: 10px;
    padding: 2rem;
    width: 90%;
    max-width: 700px;
    max-height: 85vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  }

  .close-btn {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #1E1C66;
  }
  </style>
